import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { entitiesListSelector } from 'selectors';
import highlightingService from 'services/highlightingService';

import DNADatum from './DNADatum';
import DNAGraphLabels from './DNAGraphLabels';

class DNAGraph extends PureComponent {
  componentDidMount() {
    highlightingService.registerDNAGraph();
  }

  renderData = () => {
    return this.props.recommendations.slice(0, 100).map(recommendation => {
      return (
        <DNADatum key={recommendation.uuid} recommendation={recommendation} />
      );
    });
  };

  render() {
    const { recommendations } = this.props;
    const noRecommendations = !recommendations.length;
    const className = `DNAGraph-holder ${
      noRecommendations ? 'no-recommendations' : ''
    }`;
    const { length } = recommendations;
    return (
      <div className={className}>
        <div className="DNAGraph-title">
          <h2>Summary</h2> <span>(Top {length} results)</span>
        </div>
        <div className="DNAGraph" id="DNAGraph">
          {this.renderData()}
        </div>
        <DNAGraphLabels recommendationsCount={length} />
      </div>
    );
  }
}

DNAGraph.propTypes = {
  recommendations: PropTypes.arrayOf(PropTypes.object).isRequired,
};

function mapStateToProps(state) {
  return {
    recommendations: entitiesListSelector(state, 'recommendations'),
  };
}

export default connect(mapStateToProps)(DNAGraph);



// WEBPACK FOOTER //
// ./src/Components/Pages/Results/DNAGraph/DNAGraph.js